import { createFileRoute } from "@tanstack/react-router";
import { AssignedWellbeingReferralsPage } from "@features/wellbeing-referrals/components/AssignedWellbeingReferralsPage";

export const Route = createFileRoute("/_layout/referrals/wellbeing/assigned")({
	component: Page,
    staticData: {
        crumb: {
            label: "Assigned to me",
        },
    },
});
function Page() {
	return <AssignedWellbeingReferralsPage />;
}
